
















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account } from "@/models/account";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action } from "vuex-class";
import { Order } from "@/models/order";
import { Package } from "@/models/package";
import billingAPI from "@/services/billing";
import ProductIcon from "@/components/ProductIcon.vue";
import { BundleWithQTY } from "@/models/bundle";
import { NSLog } from "@/helpers/log";
const log = NSLog("view/Cart/BundleItem");

@Component({
  components: {
    ProductIcon
  }
})
export default class Cart extends Vue {
  @Prop({ required: true }) private item!: Package[];

  private bundles: BundleWithQTY[] = [];
  private loading = false;

  get canIncDec() {
    return true; //this.item && this.item.category !== "shipping";
  }

  get bundle() {
    return this.bundles.find((b) => this.item[0].bundle_id == b.id);
  }

  get discountRate() {
    return this.item[0].discount_rate;
  }

  get qty() {
    let minQty = 0;
    for (const pkg of this.item) {
      if (minQty == 0 || pkg.qty < minQty) minQty = pkg.qty;
    }
    return minQty;
  }

  get currency() {
    return this.item[0].currency;
  }

  get price() {
    return this.total / this.qty;
  }

  get total() {
    return this.item.reduce((t, p) => t + p.price * p.qty * ((100 - this.discountRate) / 100), 0);
  }

  inc() {
    if (!this.bundle || !this.bundle.package_short_codes) return;

    const anyPkgOfBundle = this.item[0];
    const discount_rate = anyPkgOfBundle.discount_rate;

    this.bundle.package_short_codes.map((short_code) => {
      log("inc", short_code);
      this.$emit("inc", {
        code: short_code,
        discount_rate: discount_rate,
        bundle_id: this.bundle!.id,
      });
    })
  }

  dec() {
    if (!this.bundle || !this.bundle.package_short_codes) return;

    const anyPkgOfBundle = this.item[0];
    const discount_rate = anyPkgOfBundle.discount_rate;

    this.bundle.package_short_codes.map((short_code) => {
      log("dec", short_code);
      this.$emit("dec", {
        code: short_code,
        discount_rate: discount_rate,
        bundle_id: this.bundle!.id,
      });
    })
  }

  private async mounted() {
    this.loading = true;
    try {
      this.bundles = await billingAPI.listBundles();
    } catch (err) {
      log("err", err);
    }

    this.loading = false;
  }
}
